
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/no-waste",
      function () {
        return require("private-next-pages/article/no-waste.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/no-waste"])
      });
    }
  